import { validateSchema } from 'src/feathers/hooks';
import yup from 'src/feathers/yup';

const cleanup = async (context) => {
  await context.app.cleanup();
  return context;
};

export default (app) => {
  app.service('authentication').schema = yup.object({
    email: yup.trimmedString().email().required().label('Email'),
    password: yup.trimmedString().required().label('Password')
  });

  app.service('authentication').hooks({
    after: {
      create: [
        async (context) => {
          await app.get('stateContainer').setState({
            authenticated: true
          });
          return context;
        }
      ],
      remove: [cleanup]
    },
    // If you log out with an expired/invalid token, the server will error.
    // This is expected behavior on the server bc you have to have a valid
    // token in order to logout. But we don't care about the error here. Even
    // if serverside logout failed, wipe the client authentication
    error: {
      remove: [cleanup]
    }
  });

  // Reset PW
  app.service('auth/reset-password').schema = yup.object({
    password_reset_token: yup
      .trimmedString()
      .required()
      .label('Password reset token'),
    password: yup.trimmedString().required().label('Password').password()
  });
  app.service('auth/reset-password').hooks({
    before: {
      create: [validateSchema]
    }
  });

  // Forgot PW
  app.service('auth/forgot-password').schema = yup.object({
    email: yup.trimmedString().email().required().label('Email')
  });
  app.service('auth/forgot-password').hooks({
    before: {
      create: [validateSchema]
    }
  });
};
